import { createContext, useEffect, useState } from "react";
import Category from "./Category";
import Nav from "./Nav";
import NavCategories from "./NavCategories";
import NavTop from "./NavTop";
import "./navbar.css";
import * as main_category from "../../network/api/maincategory";
import Logo from "./Images/logoo.svg";
import { BsSearch } from "react-icons/bs";
import { FiMenu } from "react-icons/fi";
import Sidebar from "./Sidebar";
import LoginImage from "./Images/login.png";
import LogForm from "../Login/LogForm";
import cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
export const CategoryContext = createContext();

function Navbar({ lang, langcode, personal, update_p }) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const token = cookies.get("user");
  const [showCategory, setShowCategory] = useState(false);
  const [categories, setCategories] = useState([false]);
  const [selectedCategory, setSelectedCategory] = useState({});
  const [searchKey, setSearch] = useState();
  const [searchActive, setSearchActive] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [id, setId] = useState("");

  showSidebar
    ? document.body.classList.add("stop-scrolling")
    : document.body.classList.remove("stop-scrolling");

  useEffect(() => {
    main_category
      .getcategories()
      .then((result) => {
        const list = result?.data?.response || [];
        setCategories(list);
        const firstId = list?.[0]?._id;
        if (firstId) setId(firstId);
      })
      .catch(() => {
        setCategories([]);
      });
  }, []);
  const handleKeyPress = (e) => {
    // Check if the pressed key is Enter
    if (e.key === "Enter" && searchKey.trim() !== "") {
      let page = 1;
      // Trigger navigation to another component
      navigate(`/search-results/${searchKey}/${page}`);
      setSearch("")
    }
  };
  return (
    <div className="">
      <div className="d-none d-lg-block ">
        <NavTop lang={lang} langcode={langcode} />
      </div>
      <Nav personal={personal} update_p={update_p} />
      <div className="mob-nav container d-block d-lg-none ">
        <div className="d-flex justify-content-between align-items-center p-2">
          <div
            className={`mob-search d-flex ${searchActive && "mob-search-active"
              }`}
          >
            <p onClick={() => setSearchActive(!searchActive)}>
              <BsSearch />
            </p>
            {searchActive && (
              <input
                type="text"
                value={searchKey}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={t("searchItem")}
                onKeyPress={handleKeyPress}
              />
            )}
            {/*   const handleKeyPress = (e) => {
    // Check if the pressed key is Enter
    if (e.key === 'Enter'&& searchKey.trim() !== '') {
      let page=1
      // Trigger navigation to another component
      navigate(`/search-results/${searchKey}/${page}`);
    }
  };
    <input
                type="text"
                name="search"
                value={searchKey}
                placeholder=" انت بتدور علي اية ؟"
                onChange={(e) => {setSearch(e.target.value)}}
                onKeyPress={handleKeyPress}
                className="flex-grow-1"
              /> */}
          </div>
          <img
            alt="Amun City Logo"
            onClick={() => {
              navigate(`/`);
            }}
            style={{ cursor: "pointer", width: "82px", height: "62px" }}
            src={Logo}
          />

          {token ? (
            <span
              className="fs-1"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setShowSidebar(true);
              }}
            >
              <FiMenu />
            </span>
          ) : (
            <Link to="#Login" data-bs-toggle="modal">
              <img alt="Login" src={LoginImage} className="login" />
            </Link>
          )}
        </div>
      </div>
      <div className="d-block d-lg-none">
        {showSidebar && <Sidebar setShowSidebar={setShowSidebar}></Sidebar>}
      </div>
      <div style={{background:'#f5f5f5'}}>
        <CategoryContext.Provider
          value={{
            showCategory,
            setShowCategory,
            selectedCategory,
            setSelectedCategory,
            categories,
          }}
        >
          <NavCategories />
          {/* {showCategory && <Category />} */}
        </CategoryContext.Provider>
      </div>
    </div>
  );
}
export default Navbar;
